import { get } from '@eika-infrastruktur/request';

import type { WispSignalResponse } from '../generated-types';
import { CONTEXT_PATH } from './index';

const getWispSignal = async (): Promise<WispSignalResponse> => get(`${CONTEXT_PATH}/rest/resource/wispsignal`);

export default getWispSignal;
